import React from 'react';
import { Chip, styled } from '@mui/material';
import { Icon } from '../Icon';
import { getStatusIcon } from '../../../utils';

export interface StatusBadgeProps {
  status: string;
  message?: string;
  className?: string;
}

const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'statusType'
})<{ statusType: string }>(({ theme, statusType }) => {
  // Map status types to colors
  const getColorConfig = (status: string) => {
    const completedStates = ['completed', 'business_onboarding_completed'];
    const warningStates = ['popup_closed', 'timeout', 'cancelled_by_user'];
    const errorStates = ['error', 'authentication_failed', 'sdk_unavailable', 'launch_failed'];

    if (completedStates.includes(status)) {
      return {
        backgroundColor: '#dcfce7', // green-100
        color: '#166534', // green-800
      };
    } else if (warningStates.includes(status)) {
      return {
        backgroundColor: '#fed7aa', // orange-100
        color: '#9a3412', // orange-800
      };
    } else if (errorStates.includes(status)) {
      return {
        backgroundColor: '#fecaca', // red-100
        color: '#991b1b', // red-800
      };
    } else {
      return {
        backgroundColor: '#dbeafe', // blue-100
        color: '#1e40af', // blue-800
      };
    }
  };

  const colorConfig = getColorConfig(statusType);

  return {
    height: 'auto',
    fontSize: '0.75rem',
    fontWeight: 600,
    padding: theme.spacing(0.5, 1.5),
    borderRadius: theme.spacing(0.5),
    ...colorConfig,
    '& .MuiChip-icon': {
      fontSize: '1rem',
      marginLeft: 0,
      marginRight: theme.spacing(0.5),
      color: 'inherit',
    },
  };
});

export const StatusBadge: React.FC<StatusBadgeProps> = ({ 
  status, 
  message, 
  className = '' 
}) => {
  const iconName = getStatusIcon(status);

  return (
    <StyledChip
      statusType={status}
      className={className}
      icon={<Icon name={iconName as any} />}
      label={message}
      variant="filled"
    />
  );
};